module.exports = __webpack_public_path__ + "static/receptionist-hero-overlay-76ca79abeb753abe6aba966337bd2a8f.jpg";